import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Button } from 'react-bootstrap5';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import { ContextProvider as PolicyPlansContextProvider } from 'components/PolicyPlans/Context';
import { ContextProvider as TeamsContextProvider } from 'components/Managers/Teams/Context';
import { ContextProvider as CyclesContextProvider } from 'components/Cycles/Context';
import { useContext } from 'components/Managers/Dashboard/Context';
import Alert from 'components/new_ui/Alerts/alert';
import PolicyPlanFilter from './PolicyPlanFilter';
import TeamFilter from './TeamFilter';
import CycleFilter from './CycleFilter';

export default function Index({ policyEnabled }) {
  const { dispatch, actions, state: { filters, statistics } } = useContext();

  const params = {
    team_id: filters.teamId || '',
    cycle_id: filters.cycleId || '',
    policy_plan_id: filters.policyPlanId || '',
  };
  const urlParams = new URLSearchParams(params).toString();

  const onDownloadReportClick = () => {
    actions.generateReport(urlParams);

    Alert({
      title: 'Report Generation In Progress!',
      text: `Your Team Performance Report will be processed and sent to your inbox. 
      Please check your email to access the report.`,
    });
  };

  useEffect(() => {
    actions.loadStatistics(dispatch, filters, () => {});
  }, [filters.policyPlanId, filters.teamId, filters.cycleId]);

  return (
    <section>
      <Row className="mb-3">
        <Col>
          <h1>Health and Performance</h1>
        </Col>

        <Col xs="auto">
          <Button onClick={onDownloadReportClick}>
            Download report
          </Button>
        </Col>
      </Row>

      {policyEnabled && (
        <Row className="mb-3">
          <Col xs="auto">
            <span className="me-2 fw-light text-gray">Effective date:</span>
            <span className="fw-semibold">
              {statistics.effective_date || <LoadingPlaceholder placement="inline" />}
            </span>
          </Col>

          <Col xs="auto">
            <span className="me-2 fw-light text-gray">Renewal date:</span>
            <span className="fw-semibold">
              {statistics.renewal_date || <LoadingPlaceholder placement="inline" />}
            </span>
          </Col>
        </Row>
      )}

      <Row>
        {policyEnabled && (
          <Col md="6">
            <Row>
              <PolicyPlansContextProvider>
                <PolicyPlanFilter />
              </PolicyPlansContextProvider>
            </Row>
          </Col>
        )}

        <TeamsContextProvider>
          <Col md="6">
            <TeamFilter />
          </Col>

          <Col md="6">
            <CyclesContextProvider>
              <CycleFilter />
            </CyclesContextProvider>
          </Col>
        </TeamsContextProvider>
      </Row>
    </section>
  );
}

Index.propTypes = {
  policyEnabled: PropTypes.bool.isRequired,
};
